import { FilterType } from "./filters";
import { useSearchParam } from "../../utils/useSearchParam";
import { navigateWithParamsForFiltering } from "../../utils/navigate-with-params";

export type SelectionPredicate = (filter: FilterType) => boolean;
export type SelectionMutator = (selections: Record<string, boolean>) => void;

export interface FilterSelectionState {
  setSelected: SelectionMutator;
  isSelected: SelectionPredicate;
  setFilterSelection: (newSelection: string[]) => void;
  filterSelection: string[];
}

export const useFilterSelectionState = (): FilterSelectionState => {
  const filtersParamName = "filters";
  const filtersParam = useSearchParam(filtersParamName) || "";
  const filterSelection = filtersParam
    .trim()
    .split(",")
    .filter(x => !!x);
  const navigateToState = (newSelected: string[]) => {
    const search =
      newSelected.length && newSelected.map(encodeURIComponent).join(",");
    navigateWithParamsForFiltering(
      search ? { [filtersParamName as string]: search } : {}
    );
  };

  const setFilterSelection = (selected: string[]) => navigateToState(selected);

  const isSelected = (filter: FilterType) =>
    !!filterSelection.find(id => id === filter._id);

  /**
   * Update the selection status of the given filters.
   *
   * @param selections The filters ids to change. Unspecified filters are unaffected.
   */
  const setSelected = (selections: Record<string, boolean>) => {
    const withoutMentioned = filterSelection.filter(
      id => !selections.hasOwnProperty(id)
    );
    setFilterSelection([
      ...Object.keys(selections).filter(x => selections[x]),
      ...withoutMentioned
    ]);
  };
  return {
    setSelected,
    isSelected,
    setFilterSelection,
    filterSelection
  };
};
